// Remembers the account theme's CSS variables so a page reload paints loaders (and the rest of the
// shell) in the account colours straight away, instead of the static default until the host/account
// call returns. public/index.html restores the cached values before the bundle runs; keep
// THEME_CACHE_KEY in sync with the inline script there.
export const THEME_CACHE_KEY = "dc_theme_vars";

// Sets each { "css-var-name": value } on :root, caches them, and marks the theme as resolved.
export const applyThemeVars = (vars) => {
    const root = document.documentElement;
    if (vars && Object.keys(vars).length) {
        Object.entries(vars).forEach(([key, val]) => root.style.setProperty(`--${key}`, val));
        try {
            localStorage.setItem(THEME_CACHE_KEY, JSON.stringify(vars));
        } catch (e) {
            // storage unavailable (private mode / quota) - the theme still applies for this visit
        }
    }
    markThemeReady();
};

// Loaders fall back to a neutral colour until this is set (see .dc-loader-* in custom.css).
export const markThemeReady = () => {
    document.documentElement.setAttribute("data-theme-ready", "1");
};
